import { forwardRef } from "react";

import { Search } from "@assets";
import { Cross } from "@assets/svg/Cross";
import { TextInput, TextInputRef } from "@components/Input/TextInput";
import { SearchInputProps } from "./types";

export const SearchInput = forwardRef<TextInputRef, SearchInputProps>(
  ({ value, setValue = () => null, showLeftIcon = true, ...rest }, ref) => {
    const clearInput = () => {
      setValue("");
    };

    return (
      <TextInput
        ref={ref}
        value={value}
        onRightIconClick={clearInput}
        onChangeText={(text) => setValue(text)}
        {...(showLeftIcon && { leftIcon: <Search /> })}
        {...(value && { rightIcon: <Cross /> })}
        {...rest}
      />
    );
  },
);
